(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sire90-hero"]) return;
  try {
    
(() => {
  if (!document.body.classList.contains('sire90')) return;
  const campaignKeys = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','fbclid','country','preview_theme_id'];
  const withCampaign = (path) => {
    const target = new URL(path, location.origin);
    const incoming = new URLSearchParams(location.search);
    for (const key of campaignKeys) if (incoming.has(key)) target.searchParams.set(key, incoming.get(key));
    return target;
  };
  for (const form of document.querySelectorAll('[data-s90-form]')) {
    form.elements.return_to.value = withCampaign(form.dataset.cartUrl).pathname + withCampaign(form.dataset.cartUrl).search;
  }
  let busy = false;
  let locked = [];
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-s90-form]');
    if (!form) return;
    event.preventDefault();
    if (busy) return;
    const button = form.querySelector('button[type="submit"]');
    if (button.disabled) return;
    busy = true;
    locked = [...document.querySelectorAll('[data-s90-form] button[type="submit"]:not(:disabled)')];
    locked.forEach(item => { item.disabled = true; });
    form.setAttribute('aria-busy','true');
    const label = button.querySelector('[data-s90-label]');
    const initial = label.textContent;
    label.textContent = form.dataset.loading;
    const status = form.querySelector('[role="status"]');
    const recovery = form.querySelector('.s90-cart-recovery');
    status.textContent = form.dataset.loading;
    recovery.hidden = true;
    recovery.href = withCampaign(form.dataset.cartUrl).href;
    try {
      const data = new FormData(form);
      data.delete('return_to');
      const endpoint = new URL(form.action);
      endpoint.pathname = endpoint.pathname.replace(/\/$/,'') + '.js';
      const response = await fetch(endpoint, {method:'POST',body:data,headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},credentials:'same-origin'});
      const result = await response.json();
      if (!response.ok || result.status) {
        status.textContent = typeof result.description === 'string' ? result.description : form.dataset.error;
        recovery.hidden = false;
      } else {
        label.textContent = form.dataset.added;
        status.textContent = form.dataset.added;
        location.assign(withCampaign(form.dataset.cartUrl).href);
        return;
      }
    } catch {
      status.textContent = form.dataset.error;
      recovery.hidden = false;
    }
    busy = false;
    form.removeAttribute('aria-busy');
    label.textContent = initial;
    locked.forEach(item => { item.disabled = false; });
  });
  window.addEventListener('pageshow', (event) => {
    if (event.persisted && busy) location.reload();
  });
  const sticky = document.querySelector('[data-s90-sticky]');
  const hero = document.querySelector('#s90-hero');
  const purchases = [...document.querySelectorAll('[data-s90-purchase]')];
  const footer = document.querySelector('#s90-footer');
  if (!sticky || !hero) return;
  let queued = false;
  const updateSticky = () => {
    queued = false;
    const height = window.visualViewport?.height || innerHeight;
    const guard = Math.max(sticky.getBoundingClientRect().height, 95);
    const nearPurchase = purchases.some(item => { const rect = item.getBoundingClientRect(); return rect.bottom > 0 && rect.top < height; });
    const footerVisible = footer && footer.getBoundingClientRect().top < height;
    const focusedControl = document.activeElement?.matches('input,textarea,select,[contenteditable="true"]');
    sticky.hidden = innerWidth >= 960 || hero.getBoundingClientRect().bottom > 0 || nearPurchase || footerVisible || focusedControl || height < 380;
    if (!sticky.hidden) document.documentElement.style.scrollPaddingBottom = `${guard + 16}px`;
  };
  const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(updateSticky); } };
  document.addEventListener('scroll',schedule,{passive:true});
  window.addEventListener('resize',schedule,{passive:true});
  window.visualViewport?.addEventListener('resize',schedule,{passive:true});
  document.addEventListener('focusin',schedule);
  document.addEventListener('focusout',schedule);
  document.addEventListener('toggle',schedule,true);
  document.addEventListener('shopify:section:load',schedule);
  updateSticky();
})();

  } catch(e) { console.error(e); }
})();
})();
